import type { PropsWithChildren, ReactNode } from "react";

import { cn } from "@krea/shared/utils";

interface IDetailsContainerProps {
  className?: string;
  title?: string | ReactNode;
  background?: boolean;
  status?: string | ReactNode;
}

export const DetailsContainer = ({
  className,
  title,
  children,
  background,
  status,
}: PropsWithChildren<IDetailsContainerProps>) => {
  return (
    <section className={cn(" mb-7", className)}>
      {title && (
        <div className="mb-5 flex flex-wrap items-center justify-between">
          {title && <h1 className="mb-0 pr-4 text-page-title">{title}</h1>}
          {status && <span>{status}</span>}
        </div>
      )}
      <div
        className={cn({
          "rounded-xl border border-gray-200 bg-white p-4": background,
        })}
      >
        {children}
      </div>
    </section>
  );
};
